import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import store from '../store';
import { getToken } from '@/utils/auth';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 100000 // 请求超时时间 default 15000
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    let language = store.getters.language;
    config.headers['Accept-Language'] = language || 'en';

    if (store.getters.token) {
      config.headers['Authorization'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.code !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      });

      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm(this.$t('others.youHaveBeenLoggedOutYouCanCancelToStayOnThisPageOrLogInAgain'), this.$t('others.confirmLogout'), {
          confirmButtonText: this.$t('others.reLogin'),
          cancelButtonText: this.$t('others.cancel'),
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        });
      }
      return Promise.reject('error');
    } else {
      return response.data;
    }
  },
  (error) => {
    console.log('err' + error); // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    });
    return Promise.reject(error);
  }
);

const getGinzaxiaomaApiUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === 'admin.ginzaxiaoma.net') {
    return 'https://api.ginzaxiaoma.com';
  } else {
    return 'https://test-api.ginzaxiaoma.com';
  }
};

// 创建axios实例
export const serviceAPI = axios.create({
  baseURL: getGinzaxiaomaApiUrl(), // api的base_url
  timeout: 100000 // 请求超时时间 default 15000
});

// request拦截器
serviceAPI.interceptors.request.use(
  (config) => {
    let language = store.getters.language;
    config.headers['Accept-Language'] = language || 'en';

    if (store.getters.token) {
      config.headers['Authorization'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
serviceAPI.interceptors.response.use(
  (response) => {
    return Promise.resolve(response.data)
  },
  (error) => {
    console.log('err' + error); // for debug
    Message({
      message: error.response.data.message || error.message,
      type: 'error',
      duration: 3 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js